import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./CountdownTimer.css";
import { useSelector } from "react-redux";
// Import react-circular-progressbar module and styles
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { circularPercentage } from "utils/commonMethods";
//Renders timer in descreasing order.
function CountdownTimer({ num, onTimerComplete, concatenateText = "" }) {
  const vendingMachineDetails = useSelector((state) => state.vmDetailsReducer);

  let [timeNum, setNumber] = useState({
    number: num,
    minutes: null,
    seconds: null,
  });

  let timer;
  if (timeNum.number > 0) {
    timer = setInterval(() => {
      let number = Math.max(timeNum.number - 1, 0);
      let seconds = parseInt(number % 60); // Seconds that cannot be written in minutes
      let secondsInMinutes = parseInt((number - seconds) / 60); // Gives the seconds that COULD be given in minutes
      let minutes = parseInt(secondsInMinutes % 60); // Minutes that cannot be written in hours
      // var hours = (secondsInMinutes - minutes) / 60;
      setNumber({
        ...timeNum,
        number: number,
        minutes: minutes,
        seconds: seconds,
      });
      clearInterval(timer);
    }, 1000);
  } else {
    //Calls callback
    onTimerComplete();
  }

  useEffect(() => {
    return () => {
      clearInterval(timer);
    };
  }, [timeNum]);

  return (
    <div className="countdown-timer-main">
      <CircularProgressbarWithChildren
        value={circularPercentage(
          timeNum.number,
          vendingMachineDetails.configurations.dispense_later_timeout
        )}
        styles={buildStyles({
          textColor: "red",
          pathColor: "red",
          trailColor: "light-grey",
        })}
      >
        {/* Put any JSX content in here that you'd like. It'll be vertically and horizonally centered. */}
        <div className="countdown-time">
          {" "}
          <span>
            {timeNum.number > 0
              ? `${timeNum.minutes ? timeNum.minutes : "0"}:${
                  timeNum.seconds ? timeNum.seconds : "00"
                }`
              : "0:00"}
          </span>
        </div>
        <div className="countdown-timer-unit">Min&nbsp;:&nbsp;Sec</div>
      </CircularProgressbarWithChildren>
    </div>
  );
}

CountdownTimer.propTypes = {
  num: PropTypes.number.isRequired,
  onTimerComplete: PropTypes.func.isRequired,
  concatenateText: PropTypes.string,
};

export default CountdownTimer;
